import { render, staticRenderFns } from "./operationSquare.vue?vue&type=template&id=b40e5e90&scoped=true"
import script from "./operationSquare.vue?vue&type=script&lang=js"
export * from "./operationSquare.vue?vue&type=script&lang=js"
import style0 from "./operationSquare.vue?vue&type=style&index=0&id=b40e5e90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e5e90",
  null
  
)

export default component.exports